import { render, staticRenderFns } from "./baseSelectPerson.vue?vue&type=template&id=b4418362&scoped=true&"
import script from "./baseSelectPerson.vue?vue&type=script&lang=ts&"
export * from "./baseSelectPerson.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4418362",
  null
  
)

export default component.exports